import {Row} from 'antd';
import classes from '../Pages.module.css';
import NormDataField from './NormDataField'

const BasiCSalaryDetails = (props) => {

    const handleChange = (e,param) => {

        props.setData(data => {
            const newdata = [...data['header']['rows']]
            newdata[0][param] = e.target.value
            return({
                ...data,
                header : {
                    ...data.header,
                    rows: newdata
                }
            })
        })
    }

    const handleDChange = (date, dateString, param) => {

        props.setData(data => {
            const newdata = [...data['header']['rows']]
            newdata[0][param] = dateString
            return({
                ...data,
                header : {
                    ...data.header,
                    rows: newdata
                }
            })
        })
    }

    const handleSChange = (val,param) => {

        props.setData(data => {
            const newdata = [...data['header']['rows']]
            newdata[0][param] = val
            return({
                ...data,
                header : {
                    ...data.header,
                    rows: newdata
                }
            })
        })
    }

    return(
        <div>
  <p></p>
  <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
    <NormDataField
      editMode={props.editMode}
      lg={4}
      md={24}
      handleChange={handleSChange}
      options={props.ad.EMPLOYEE_CODE}
      type="Select"
      name="Employee Name"
      param="employee_code"
      value={props.data.employee_code ? props.data.employee_code : null}
    />
    {!props.create && (
      <NormDataField
        editMode={props.editMode}
        lg={4}
        md={24}
        handleChange={handleChange}
        name="Salary Norms Code"
        param="salary_norms_hdr_code"
        value={props.data.salary_norms_hdr_code ? props.data.salary_norms_hdr_code : null}
      />
    )}
    <NormDataField
      editMode={props.editMode}
      lg={4}
      md={24}
      handleChange={handleSChange}
      options={props.ad.EMPLOYEE_TYPE}
      type="Select"
      name="Employee Type"
      param="emp_type"
      value={props.data.emp_type ? props.data.emp_type : null}
    />
    <NormDataField
      editMode={props.editMode}
      lg={4}
      md={24}
      handleChange={handleSChange}
      options={props.ad.STATE_CODE}
      type="Select"
      name="State"
      param="state_code"
      value={props.data.state_code ? props.data.state_code : null}
    />
    <NormDataField
      editMode={props.editMode}
      lg={4}
      md={24}
      handleChange={handleSChange}
      options={props.ad.DEPARTMENT_CODE}
      type="Select"
      name="Department"
      param="department_code"
      value={props.data.department_code ? props.data.department_code : null}
    />
    <NormDataField
      editMode={props.editMode}
      lg={4}
      md={24}
      handleChange={handleSChange}
      options={props.ad.DESIGNATION_CODE}
      type="Select"
      name="Designation"
      param="designation_code"
      value={props.data.designation_code ? props.data.designation_code : null}
    />
    {/* <NormDataField
      editMode={props.editMode}
      lg={12}
      md={24}
      handleChange={handleSChange}
      options={props.ad.BRANCH_CODE}
      type="Select"
      name="BRANCH"
      param="branch_code"
      value={props.data.branch_code ? props.data.branch_code : null}
    /> */}
    <NormDataField
      editMode={props.editMode}
      lg={4}
      md={24}
      handleChange={handleChange}
      name="Gross salary"
      param="gross_sal"
      value={props.data.gross_sal ? props.data.gross_sal : null}
    />
  </Row>
  <p></p>
  <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
    <NormDataField
      editMode={props.editMode}
      lg={4}
      md={24}
      handleChange={handleChange}
      name="Salary Form"
      param="gross_from"
      value={props.data.gross_from ? props.data.gross_from : null}
    />
    <NormDataField
      editMode={props.editMode}
      lg={4}
      md={24}
      handleChange={handleChange}
      name="Salary To"
      param="gross_to"
      value={props.data.gross_to ? props.data.gross_to : null}
    />
    <NormDataField
      editMode={props.editMode}
      lg={4}
      md={24}
      handleChange={handleDChange}
      type="Date"
      name="From Date"
      param="from_date"
      value={props.data.from_date ? props.data.from_date : null}
    />
    <NormDataField
      editMode={props.editMode}
      lg={4}
      md={24}
      handleChange={handleDChange}
      type="Date"
      name="To Date"
      param="to_date"
      value={props.data.to_date ? props.data.to_date : null}
    />
  </Row>
  <p></p>
</div>

    );
}

export default BasiCSalaryDetails